import BrandedTracking from './BrandedTracking.component';
import BrandedTrackingModal from './BrandedTrackingModal.component';

export default {
	BrandedTracking,
	BrandedTrackingModal,
};
